import { BASE_URL, fetchData, patchData, postData } from "."

const MODULE_PATH = "/messages"

export default {
  async getMessageCounts(storeId?: number): Promise<MessageCount[]> {
    let url = `${MODULE_PATH}`
    if (storeId) url += `?StoreId=${storeId}`
    const data = await fetchData<MessageCount[]>(url)
    data.forEach((x) => {
      if (x.lastMessageTime) x.lastMessageTime = new Date(x.lastMessageTime + "+00:00")
    })
    return data
  },
  async getMessages(driverId: number): Promise<Message[]> {
    const url = `${MODULE_PATH}/${driverId}`
    const data = await fetchData<Message[]>(url)
    data.forEach((x) => {
      if (x.sentTime) x.sentTime = new Date(x.sentTime + "+00:00")
    })
    return data
  },
  setAsRead(messageId: string): Promise<void> {
    const url = `${MODULE_PATH}/${messageId}/Read`
    return patchData(url, {})
  },
  getImageUrl(messageId: string): string {
    return `${BASE_URL}${MODULE_PATH}/${messageId}/Image`
  },
  sendMessage(driverId: number, msg: NewMessage): Promise<string> {
    const url = `${MODULE_PATH}/${driverId}`
    const form = new FormData()
    Object.keys(msg).forEach((key) => {
      const val = (msg as unknown as Record<string, string | Blob>)[key]
      form.append(key, val)
    })
    return postData(url, form)
  }
}

export interface MessageCount {
  driverId: number
  driverName: string
  unreadMessages: number
  lastMessageText: string
  lastMessageTime: Date | null
}

export interface Message {
  messageId: string
  messageText?: string
  sentTime: Date
  fromDriver: boolean
  hasAttachment: boolean
  userName?: string
  isDelivered: boolean
  isRead: boolean
}

export interface NewMessage {
  messageText: string
  attachmentData?: File
  attachmentType?: string
}
